import axios from 'axios';
import BaseAPI from './base/base-api';

class AcceptCheckingResultAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'acceptcheckingresult';
}

export default new AcceptCheckingResultAPI();
